export const adUnits = {
	richMediaPortrait: {
		text: 'Rich media portrait and Vertical video interstitial',
		url: 'web_fullscreen_portrait',
        preview: 'webfullscreen',
        alternate: 'Phone/Tablet Fullscreen (P) or Phone/Tablet Video Fullscreen (P)',
        selected: false,
        ak: '',
        container: 'fullscreen',
        type: 'HTML',
        hasError: false
	},
	inView: {
		text: 'In-view video banner',
		url: 'flex_inview',
        preview: null,
        selected: false,
        alternate: 'Phone/Tablet Video Fullscreen (L)',
        ak: '',
        autoClose: false,
        container: 'inview',
        type: 'VAST',
        hasError: false
	},
	expandableBanner: {
		text: 'Expandable banner (320x50)',
		url: 'flex_expandable_banner',
        preview: 'expandableBanner',
        alternate: 'Banner 320x50',
        selected: false,
        ak: '',
        container: 'expandable_banner',
        type: 'HTML',
        hasError: false
    },
    safeInFeedLandscape: {
        text: 'In-feed landscape video',
        url: 'flex_sf_video',//safeframe_video
        preview: 'safeInFeedLandscape',
        alternate: 'Phone/Tablet Video Fullscreen (L)',
        selected: false,
        ak: '',
        container: 'vast_safe',
        type: 'VAST',
        isSafeFrame: true,
        hasError: false
    },
    htmlRichMedia: {
        text: 'HTML Rich Media ad',
        url: 'flex_sf_html',//safeframe_html
        preview: 'htmlRichMedia',
        alternate: 'Phone/Tablet Fullscreen (P)',
        selected: false,
        ak: '',
        container: 'scroller_safe',
        type: 'HTML',
        isSafeFrame: true,
        hasError: false
    },
    phoneBanner: {
        text: 'Phone banner (320x50)',
        url: 'flex_banner',
        preview: 'phoneBanner',
        alternate: 'Banner 320x50',
        selected: false,
        bannerType: 0,
        ak: '',
        container: 'webinfeed_static',
        type: 'HTML',
        hasError: false
    },
    mpu: {
        text: 'MPU (300x250)',
        url: 'flex_mpu',
        preview: 'mpu',
        alternate: 'Medium Rectangle 300x250',
        selected: false,
        bannerType: 1,
        ak: '',
        container: 'webinfeed_static',
        type: 'HTML',
        hasError: false
    },
    leaderboard: {
        text: 'Tablet leaderboard (728x90)',
        url: 'flex_leaderboard',
        preview: 'leaderboard',
        alternate: 'Tablet leaderboard 728x90',
        selected: false,
        bannerType: 2,
        ak: '',
        container: 'webinfeed_static',
        type: 'HTML',
        hasError: false
    },
    skyscraper: {
        text: 'Desktop Skyscraper (120x600)',
        url: 'flex_skyscraper',
        preview: 'skyscraper',
        alternate: 'Desktop Skyscraper 120x600',
        selected: false,
        bannerType: 3,
        ak: '',
        container: 'webinfeed_static',
        type: 'HTML',
        hasError: false
    },
    halfpage: {
        text: 'Desktop Half Page (300x600)',
        url: 'flex_halfpage',
        preview: 'halfpage',
        alternate: 'Desktop Half Page 300x600',
        selected: false,
        bannerType: 4,
        ak: '',
        container: 'webinfeed_static',
        type: 'HTML',
        hasError: false
    },
    fullscreenPortraitScroller: {
        text: 'Portrait scroller',
        url: 'flex_scroller',
        preview: 'fullscreenPortraitScroller',
        alternate: 'Scroller',
        selected: false,
        ak: '',
        container: 'scroller',
        type: 'HTML',
        hasError: false
    },
    inFeedPortrait: {
        text: 'In-feed portrait/vertical video',
        url: 'flex_infeed',
        preview: 'inFeedPortrait',
        alternate: 'Phone/Tablet Video Fullscreen (P)',
        selected: false,
        ak: '',
        autoClose: false,
        container: null,
        type: 'VAST',
        isPortrait: true,
        hasError: false
    },
    inFeedLandscape: {
        text: 'In-feed landscape video',
        url: 'flex_vast',
        preview: 'inFeedLandscape',
        alternate: 'Phone/Tablet Video Fullscreen (L)',
        selected: false,
        ak: '',
        autoClose: false,
        vcr: false,
        container: null,
        type: 'VAST',
        hasError: false
    },
    passback: {
        text: 'Passback tag',
        alternate: '',
        selected: false,
        ak: '',
        hasError: false,
        height: 250,
        width: 320
    }
};
